<header></header>
<div class="post-login-1">
  <div class="post-login-1-col-1 h-100">
    <!-- <left-panel activeTab="4" *ngIf="this.auth?.detailuser"></left-panel>
    <app-left-panel-prelogin activeTab="4" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin> -->
    <left-panel activeTab="4" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    <app-left-panel-prelogin activeTab="4" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
  </div>
  <div class="post-login-1-col-2">
    <div class="discover-box">
      <grid-row>
        <grid-col col="4" ipad="12">
          <div class="font-600 font-size-32px line-h-40 letter-spacing-03">
            {{"ExploreVariety" | translate }}
          </div>
        </grid-col>
      </grid-row>

      <div class="carousel-wrapper mt-10" *ngIf="this.serviceType === 'Conventional'">
        <owl-carousel-o [options]="carouselOptions">
          <ng-template carouselSlide>
            <div class="img-box">
              <img src="assets/images/Dashborad1.png" alt="Dashboard 1">
              <div class="text-box">
                <div *ngIf="serviceType === 'Conventional'">
                  {{ "OfferPersonalLoan" | translate }}
                </div>
                <div *ngIf="serviceType === 'Islamic'">
                  {{ "OfferPersonalFinance" | translate }}
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template carouselSlide>
            <div class="img-box">
              <img src="assets/images/DashboardCard.png" alt="Credit Card">
              <div class="text-box">
                {{ "imtiazCreditCard" | translate }}
              </div>
            </div>
          </ng-template>

          <ng-template carouselSlide>
            <div class="img-box">
              <img src="assets/images/DashboardInsurance.png" alt="Insurance">
              <div class="text-box">
                {{ "insurance" | translate }}
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
      
      <div class="carousel-wrapper mt-10" *ngIf="this.serviceType === 'Islamic'">
          <owl-carousel-o [options]="carouselOptions">
            <ng-template carouselSlide>
              <div class="img-box">
                <img src="~/../assets/images/islamic-finance.png" alt="">
                <div class="text-box">
                  <!-- <div class="font-600 font-size-20px line-h-32 color-base-100">
                  {{"OfferPersonalLoan"|translate}}
                </div> -->
                  <div class="font-600 font-size-20px line-h-32 color-base-100"
                    *ngIf="this.serviceType === 'Conventional'">
                    {{"OfferPersonalLoan"|translate}}
                  </div>
                  <div class="font-600 font-size-20px line-h-32 color-base-100" *ngIf="this.serviceType === 'Islamic'">
                    {{"OfferPersonalFinance"|translate}}
                  </div>
                </div>
                <!-- <wishlist [itemStatus]="false"></wishlist> -->
              </div>
            </ng-template>
          </owl-carousel-o>
      </div>

      <div class="mt-40">
        <grid-row class="col-space-min">
          <grid-col col="12">
            <grid-row class="justify-content-between align-item-center mb-20">
              <grid-col col="auto">
                <div class="font-600 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
                  {{ "DEALSAROUNDYOU" | translate }}
                </div>
              </grid-col>
              <grid-col col="auto">
                <div class="font-600 font-size-14px line-h-20 color-base-2200 link" (click)="landingPageOffers()">
                  {{ "ViewAll" | translate }}
                </div>
              </grid-col>
            </grid-row>
          </grid-col>
        </grid-row>

        <!-- <grid-row class="col-space-min" *ngIf="this.auth?.detailuser != null"  >
              <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6" *ngFor="let item of this.FavPaginated; let i = index">
                <div class="deal-card" >
                  <div class="card-img" (click)="Detail(item)">
                    <img src="data:image/jpg;base64,{{item.thumbnailBase64}}" alt="">
                  </div>
                  <div class="content-box">
                    <div class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                      {{item.title}}
                    </div>
                    <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                      {{item.caption}}
                    </div>
                    <grid-row>
                      <grid-col col="auto">
                        <wishlist (returnClick)="heartIcon(item.id)" *ngIf="this.auth?.detailuser!= null"></wishlist>
                      </grid-col>
                    </grid-row>
                  </div>
                </div>
              </grid-col>
            </grid-row> -->

        <grid-row class="col-space-min">
          <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6"
            *ngFor="let item of this.OfferPaginated; let i = index">
            <div class="deal-card" (click)="Detail(item)">
              <div class="card-img">
                <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                <img src="data:image/jpg;base64,{{item.thumbnailBase64}}" alt="">
              </div>
              <div class="content-box">
                <div class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                  {{item.title}}
                </div>
                <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                  {{item.caption}}
                </div>
                <grid-row class="mt-30">
                  <grid-col col="auto">
                    <wishlist (returnClick)="heartIcon(item.id)" [itemStatus]="item.heart"
                      *ngIf="this.auth?.detailuser!= null"></wishlist>
                  </grid-col>
                </grid-row>
              </div>
            </div>
          </grid-col>
        </grid-row>

      </div>

      <!-- <div class="mt-40">
        <grid-row class="col-space-min">
          <grid-col col="6" mobile="12">
            <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "OfferPersonalLoan" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/deal-1-card-img.png" alt="">
                <img src="~/../assets/images/Dashborad1.png" alt="">
              </div>
              <div class="content-box min-h-110 bg-color-base-2400">
                <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"PLoanTitile" | translate}}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"PersonalLoanDes" | translate}}
                </div>
              </div>
            </div>
          </grid-col>

          <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "CarLoan" | translate }}
            </div>
            <div class="deal-card ">
              <div class="card-img">
                <img src="~/../assets/images/Loan_Inner_Banner-Car.png" alt="">

              </div>
              <div class="content-box min-h-110 bg-color-base-2900">
                <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"ExploreCARLOANS" | translate}}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"AffordablePersonalLoans" | translate}}
                </div>

              </div>
            </div>
          </grid-col>
          <grid-col col="6" mobile="12">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "CarLoan" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/explore-card-loan-img.png" alt="">

              </div>
              <div class="content-box min-h-110 bg-color-base-2900">
                <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"ExploreCARLOANS" | translate}}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"AffordablePersonalLoans" | translate}}
                </div>

              </div>
            </div>
          </grid-col>

        </grid-row>
        <grid-row class="col-space-min mt-40 mt-mobile-15">
          <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "imtiazCreditCard" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/deal-1-card-img.png" alt="">
                <img src="~/../assets/images/DashboardCard.png" alt="">
              </div>
              <div class="content-box min-h-110 bg-color-base-2900">
                <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"imtiazCreditCard" | translate}}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"GetFirstCard" | translate}}
                </div>

              </div>
            </div>
          </grid-col>
          <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "imtiazCreditCard" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/DashboardCard.png" alt="">
              </div>
              <div class="content-box min-h-110 bg-color-base-2900">
                // <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  // {{"ExploreCreditCards" | translate}}
                //</div> 
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"GetFirstCard" | translate}}
                </div>

              </div>
            </div>
          </grid-col>
          <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "insurance" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
          <img src="~/../assets/images/deal-1-card-img.png" alt="">
          <img src="~/../assets/images/explore-card-loan-img.png" alt="">
          <img src="~/../assets/images/DashboardInsurance.png" alt="">
              </div>
              <div class="content-box min-h-110 bg-color-base-2400">
                <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"ExploreOurPersonalLoan" | translate}}
                </div>
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"InsuranceDes" | translate}}
                </div>
              </div>
            </div>
          </grid-col>
        </grid-row>
      </div> -->
    </div>

    <div class="pd mt-30" *ngIf="this.serviceType === 'Conventional'">
      <grid-row class="justify-content-center">
        <grid-col col="6" mobile="12" class="mt-mobile-15">
          <div class="br-16 bg-color-base-2400">
            <grid-row class="align-item-center">
              <grid-col col="4" ipad="5">
                <ng-icon iconClass="icon-card-girl v-align-middle bl-16-16" width="130" height="96"></ng-icon>
              </grid-col>
              <grid-col col="8" ipad="7">
                <div class="font-400 font-size-12px letter-spacing-1 line-h-20 color-base-2200 p-16">
                  {{ "GetSpecialOffersIMTIAZ" | translate }}
                </div>
              </grid-col>
            </grid-row>
          </div>
        </grid-col>
      </grid-row>
    </div>

    <!-- <div class="p-30">
      <div class="font-600 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
        {{ "InsureMe" | translate }}
      </div>
      <grid-row class="col-space-min mt-16">
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/motor-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"MotorInsurance" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20  mt-10">
                {{"GetMotorInsurance" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/medical-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"MedicalInsurance" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                {{"GetMedicalInsurance" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/life-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"Elite" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                {{"Tailoryourmotor" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/life-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"LifeInsurance" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                {{"ItsNeverTooEarly" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/home-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"HomeInsurance" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                {{"ItsNeverTooEarly" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
        <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
          <div class="deal-card">
            <div class="card-img">
              <img src="~/../assets/images/travel-insurance-img.png" alt="">
            </div>
            <div class="content-box">
              <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                {{"TravelINsurance" | translate }}
              </div>
              <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                {{"ItsNeverTooEarly" | translate }}
              </div>
            </div>
          </div>
        </grid-col>
      </grid-row>
      <div class="mt-40">
        <div class="font-600 font-size-14px line-h-20 color-base-1200 letter-spacing-1 text-uppercase">
          {{ "GetALoan" | translate }}
        </div>
        <grid-row class="col-space-min mt-16">
          <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/loan-card-1.png" alt="">
              </div>
              <div class="content-box">
                <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                  {{"PersonalLoan" | translate }}
                </div>
                <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                  {{"Affordablepersonalloans" | translate }}
                </div>
              </div>
            </div>
          </grid-col>
          <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/loan-card-2.png" alt="">
              </div>
              <div class="content-box">
                <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                  {{"FirstCarPlan" | translate}}
                </div>
                <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                  {{"Easyenoughtomake" | translate }}
                </div>
              </div>
            </div>
          </grid-col>
          <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/loan-card-2.png" alt="">
              </div>
              <div class="content-box">
                <div class="font-600 font-size-14px color-base-1500 line-h-12 letter-spacing-1 text-uppercase mt-14">
                  {{"FirstCarPlan" | translate}}
                </div>
                <div class="font-400 font-size-14px color-base-2800 letter-spacing-03 line-h-20 mt-10">
                  {{"Easyenoughtomake" | translate }}
                </div>
              </div>
            </div>
          </grid-col>
        </grid-row>
      </div>
    </div>
  </div>
  <div class="post-login-1-col-3">
    <div class="pl-20 pr-20">
      <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
        {{"Sponsored" | translate }}
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/sponsor-card-img.png" alt="">
        </div>
        <div class="content-box bg-2900">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedCashExtra" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"Applyourproduct" | translate }}
          </div>
        </div>
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
        </div>
        <div class="content-box bg-2900">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedMedicalInsurance" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"GetYourFamilyMedical" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
  </div>